import { withRouter } from '../../router';
import { AppDrawerView } from './drawer.component';
import { graphql, compose } from 'react-apollo';
import { getUserQuery } from '../../auth/graphql/getUser.query';

export const AppDrawer = compose(
  withRouter,
  graphql(getUserQuery),
)(AppDrawerView);
